var exports = {
  "Qs": "BanMemberModal.module__content___WmtWTX",
  "Ki": "BanMemberModal.module__video___WmtWTX",
  "Gf": "BanMemberModal.module__sectionTitle___WmtWTX",
};

module.exports = exports;
